import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { CacheEvent } from './cache-events';

@Injectable({ providedIn: 'root' })
export class CacheEventProvider extends DomainEventProvider<CacheEvent> {}
